import { render, staticRenderFns } from "./SubscriberRates.vue?vue&type=template&id=1172ede0&scoped=true"
import script from "./SubscriberRates.vue?vue&type=script&lang=js"
export * from "./SubscriberRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1172ede0",
  null
  
)

export default component.exports